import React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from "swiper/react";
import Value1 from '../../assets/images/ourvalue_1.png';
import Value2 from '../../assets/images/ourvalue_2.png';
import Value3 from '../../assets/images/ourvalue_3.png';

const Value = {
  breakpoints: {
        0: {
           slidesPerView: 1,
        },
        600: {
            slidesPerView: 2,
        },
        1000: {
          slidesPerView: 3,
        },
        1400: {
            margin: 60,
        },
    },
};

const valuesData = [
    {
        icon: Value1,
        title: 'Transparență',
        description: 'Oferim informații clare și complete despre servicii, pentru ca utilizatorii să poată face alegeri sigure și bine informate',
    },
    {
        icon: Value2,
        title: 'Încredere',
        description: 'Construim o relație bazată pe încredere, prin servicii de calitate și informații corecte, actualizate constant',
    },
    {
        icon: Value3,
        title: 'Reciprocitate',
        description: 'Credem într-un schimb corect și benefic pentru toți — utilizatori și furnizori — într-un mediu bazat pe sprijin și colaborare',
    }
    
];

function Ourvalue() {
    return (
        <>
            <section className="our_value_section row_am">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <span className="title_badge">Valorile noastre</span>
                        <h2>
                            <span>Principiile</span> prin care ne definim
                        </h2>
                    </div>
                    <div className="value_slider" data-aos="fade-in" data-aos-duration={1500}>
                        <Swiper className="mySwiper" id="value_slider" {...Value} spaceBetween={15} slidesPerView={3}>
                            {valuesData.map((value, index) => (
                                <SwiperSlide key={index} className="item">
                                    <div className="value_block">
                                        <div className="icon">
                                            <img src={value.icon} alt="image" />
                                        </div>
                                        <div className="text">
                                            <h3>{value.title}</h3>
                                            <p>{value.description}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Ourvalue;
